var _defs, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew325({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2,
    y1: 8,
    x2: 14,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14,
    y1: 4,
    x2: 14,
    y2: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2,
    y1: 4,
    x2: 2,
    y2: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew325);
export default __webpack_public_path__ + "static/media/Symbolpack_New_325.20678349e37a021b46c5b0652b23ec4e.svg";
export { ForwardRef as ReactComponent };